import { render, staticRenderFns } from "./Reservations.vue?vue&type=template&id=6c1e28cb&scoped=true"
import script from "./Reservations.vue?vue&type=script&lang=js"
export * from "./Reservations.vue?vue&type=script&lang=js"
import style0 from "./Reservations.vue?vue&type=style&index=0&id=6c1e28cb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1e28cb",
  null
  
)

export default component.exports